/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { findOne, hide, show } from '@/js/utils/dom'

/**
 * Preview a file selected via `input.with-preview` in the matching
 * `#preview-container-<id>` element.
 *
 * @type {Listener}
 */
export default {
    selector: 'input.with-preview',
    connect(element) {
        const onChange = () => {
            const { id } = element
            if (!id) {
                return
            }

            const preview = findOne(`#preview-container-${id}`)
            if (!preview) {
                return
            }

            const file = element.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    preview.innerHTML = `<embed class="img-fluid preview-image" src="${e.target.result}">`
                }
                reader.readAsDataURL(file)
                show(preview)
            } else {
                hide(preview)
            }
        }

        element.addEventListener('change', onChange)

        return () => element.removeEventListener('change', onChange)
    },
}
